import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';

import { MenuItem } from 'primeng/api';

import { DeviceManagerService } from '../../core/services/device-manager.service';
import { Dropdown } from 'primeng/dropdown';
import { Calendar } from 'primeng/calendar';
import { ImageAsset } from '../../api/images/image-asset-model';
import { debounceTime } from 'rxjs/operators';
import { distinctUntilChanged, Subject } from 'rxjs';

@Component({
	selector: 'mycampapp-section-toolbar',
	templateUrl: './section-toolbar.component.html',
	styleUrls: ['./section-toolbar.component.less']
})
export class SectionToolbarComponent implements OnInit
{
	@ViewChild('calendar', { static: false }) calendar!: Calendar;
	@ViewChild('search', { static: false }) searchInput!: ElementRef;

	@Input() addButtonDisabled = false;
	@Input() busy = false;
	@Input() dateRange!: Date[];
	@Input() editing = false;
	@Input() extraButtonText = '';
	@Input() extraButtonIcon = '';
	@Input() filterItems: MenuItem[] = [];
	@Input() filterLabel = '';
	@Input() filterMenuWide = false;
	@Input() hideSearchAndFilter = false;
	@Input() goButtonDisabled = false;
	@Input() itemName = '';
	@Input() sectionName = '';
	@Input() searchPlaceholder = 'Search';
	private _searchText = '';
	@Input() set searchText(value: string)
	{
		if (this._searchText === value) return;
		this._searchText = value;
		this.searchChangedSubject.next(value);
		// this.searchTextChange.emit(value);
	}
	get searchText(): string { return this._searchText; }

	@Input() extraToolbarComponents: TemplateRef<any> | null = null;

	@Output() searchTextChange = new EventEmitter<string>();
	@Output() addButtonClicked = new EventEmitter();
	@Output() extraButtonClicked = new EventEmitter();
	@Output() goButtonClicked = new EventEmitter();
	@Output() dateRangeChange = new EventEmitter<Date[]>();

	dateRangeForCalendarInput?: Date[];

	private searchChangedSubject: Subject<string> = new Subject<string>();

	constructor(public deviceManager: DeviceManagerService) { }

	ngOnInit(): void
	{
		this.searchChangedSubject.pipe(debounceTime(250), distinctUntilChanged()).subscribe(text => this.searchTextChange.emit(text));
		this.dateRangeForCalendarInput = this.dateRange;
	}

	resetSearchText(): void
	{
		this.searchText = '';
		this.searchInput.nativeElement.focus();
	}

	onAddButtonClicked(): void
	{
		this.addButtonClicked.emit();
	}

	onExtraButtonClicked(): void
	{
		this.extraButtonClicked.emit();
	}

	onGoButtonClicked(): void
	{
		this.goButtonClicked.emit();
	}

	onSearchTextChanged()
	{
		this.searchChangedSubject.next(this.searchText);
	}

	onDateInput()
	{
		if (this.dateRangeForCalendarInput == null || this.dateRangeForCalendarInput[0] == null || this.dateRangeForCalendarInput[1] == null) return;
		this.dateRange = this.dateRangeForCalendarInput;
		this.dateRangeChange.emit(this.dateRange);
	}

	onDateSelected()
	{
		if (this.dateRangeForCalendarInput == null || this.dateRangeForCalendarInput[0] == null || this.dateRangeForCalendarInput[1] == null) return;
		this.dateRange = this.dateRangeForCalendarInput!;
		this.dateRangeChange.emit(this.dateRange);
		this.calendar.toggle();
	}
}
